import { entity, list } from "./base";
import { concatModules } from "@/utility";

const initialEntity = {
  maker_id: null,
  name: "",
  name_kana: "",
  jan_code: null,
  description: "",
  net_content: "",
  container: "",
  best_before: null,
  temperature_zone: null,
  others: "",
  providing_samples: 1,
  sample_quantity: null,
  review_set_id: null,
  medium_category_id: null,
  published: 1,
  products: [],
  maker: [],
  nutrient_facts: [],
  origins: [],
  allergens: [],
  standards: [],
  images: [""],
  user_plan_only: 0
};

const productModule = {
  actions: {
    // 公開非公開の切替とか
    emailCheck({ commit }, { email, excludedId = undefined }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .post(`/administrators/emailcheck`, {
            email,
            excludedId
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {}
};

const entityModule = entity("products", initialEntity);

export const products = {
  namespaced: true,
  modules: {
    list: list("products"),
    entity: concatModules(entityModule, productModule)
  }
};
